import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@components/common/Button';
import { cn } from '@utils/cn';
const slides = [
    {
        id: '1',
        title: 'AI驱动的影视创作平台',
        subtitle: '从创意到成片，让AI助力你的每一步创作',
        image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=1920&h=1080&fit=crop&q=80',
        cta: {
            text: '开始创作',
            link: '/topics',
        },
    },
    {
        id: '2',
        title: '智能剧本创作',
        subtitle: 'AI辅助续写、改写，让灵感源源不断',
        image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=1920&h=1080&fit=crop&q=80',
        cta: {
            text: '开始创作',
            link: '/topics',
        },
    },
    {
        id: '3',
        title: '数字资产交易市场',
        subtitle: '发现优质创作素材，让作品更出彩',
        image: 'https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?w=1920&h=1080&fit=crop&q=80',
        cta: {
            text: '探索市场',
            link: '/marketplace',
        },
    },
];
export function Banner() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);
    const goToSlide = (index) => {
        setCurrentSlide(index);
    };
    const handleCTAClick = () => {
        // 直接使用当前slide的link
        const actualLink = slides[currentSlide].cta.link;
        navigate(actualLink);
    };
    return (_jsxs("section", { className: "relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-500 to-accent-500", children: [_jsx("div", { className: "relative h-[400px] md:h-[500px]", children: slides.map((slide, index) => (_jsxs("div", { className: cn('absolute inset-0 transition-opacity duration-500', index === currentSlide ? 'opacity-100' : 'opacity-0'), children: [_jsx("div", { className: "absolute inset-0 bg-cover bg-center", style: { backgroundImage: `url(${slide.image})` }, children: _jsx("div", { className: "absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70" }) }), _jsx("div", { className: "relative flex h-full items-center justify-center p-8 text-center text-white md:p-12", children: _jsxs("div", { className: "max-w-3xl", children: [_jsx("h1", { className: "mb-4 text-4xl font-bold drop-shadow-lg md:text-5xl lg:text-6xl", children: slide.title }), _jsx("p", { className: "mb-8 text-lg opacity-90 drop-shadow-md md:text-xl", children: slide.subtitle }), _jsx(Button, { variant: "primary", size: "lg", className: "bg-white text-primary-500 hover:bg-gray-100 shadow-lg", onClick: handleCTAClick, children: slide.cta.text })] }) })] }, slide.id))) }), _jsx("div", { className: "absolute bottom-6 left-1/2 flex -translate-x-1/2 gap-2", children: slides.map((_, index) => (_jsx("button", { onClick: () => goToSlide(index), className: cn('h-2 rounded-full transition-all', index === currentSlide ? 'w-8 bg-white' : 'w-2 bg-white/50 hover:bg-white/75'), "aria-label": `跳转到第 ${index + 1} 张` }, index))) })] }));
}
